module.exports = __webpack_public_path__ + "static/media/sp-1500.1c479971.jpg";